export default __webpack_public_path__ + "static/media/G0007.25fbd445.png";